exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".totaliZone{\r\n    padding:2em 0;\r\n}\r\n.totaliZone button{\r\n    margin:auto;\r\n    display: block;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/brogliacci/brogliaccio-new-detail.component.css
// module id = ../../../../../src/app/components/brogliacci/brogliaccio-new-detail.component.css
// module chunks = main